import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';
import './SafeMessageHtml.css';

const ALLOWED_TAGS = [
  'a', 'b', 'blockquote', 'br', 'div', 'em', 'h1', 'h2', 'h3', 'h4', 'hr',
  'i', 'li', 'ol', 'p', 'span', 'strong', 'u', 'ul'
];

const ALLOWED_ATTR = ['href', 'target', 'rel', 'class'];

export default function SafeMessageHtml({ html, className = '' }) {
  const cleanHtml = useMemo(() => DOMPurify.sanitize(html || '', {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    FORBID_ATTR: ['style', 'onerror', 'onclick', 'onload'],
    ADD_ATTR: ['target']
  }), [html]);

  return (
    <div
      className={`studentMessageHtml ${className}`}
      dangerouslySetInnerHTML={{ __html: cleanHtml }}
    />
  );
}
